import React from "react"
import "./FixProfileNavbar.css"
import "./ProfileNavbar.css"
// import logo from '../../assets/img/logo.png';
// import { Link } from 'react-router-dom';
// import { Dropdown } from 'semantic-ui-react';
import { withRouter } from "react-router-dom"
import "./mobileNavBar.scss"
import DropdownMenu from "react-dd-menu"
import "./react-dd-menu.css"
import { connect } from "react-redux"
// import uuid from "react-uuid"
import Auth from "../../Auth/Auth"
import { logout } from "../../redux/root.actions";

class MobileMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpen: false,
    }
  }

  btn_jump_profile = (e) => {
    e.preventDefault()
    this.props.history.push("/")
  }

  btn_jump_resume = () => {
    this.props.history.push("/resume")
  }

  btn_jump_admin_assignbookings = () => {
    this.props.history.push("/allocation");
  };

  btn_jump_admin_allavalability = () => {
    this.props.history.push("/AllAvailability");
  };

  btn_jump_admin_allteachers = () => {
    this.props.history.push("/AllTeachers")
  }

  btn_jump_admin_allcolleges = () => {
    this.props.history.push("/AllColleges")
  }

  btn_jump_admin_allarchivedcolleges = () => {
    this.props.history.push("/AllArchivedColleges")
  }

  btn_jump_admin_qualification = () => {
    this.props.history.push("/Qualifications")
  }

  btn_jump_admin_validatedocs = () => {
    this.props.history.push("/validatedocuments")
  }

  btn_jump_admin_userlogs = () => {
    this.props.history.push("/UserLogs")
  }

  btn_jump_mycalendar = () => {
    this.props.history.push("/MyCalendar")
  }

  btn_jump_joblist = () => {
    this.props.history.push("/TeacherJoblist")
  }

  btn_jump_information = () => {
    this.props.history.push("/PersonalDetails")
  }

  btn_jump_emergency = () => {
    this.props.history.push("/EmergencyContact")
  }

  btn_jump_work_location = () => {
    this.props.history.push("/PreferredWorkLocations");
  };

  btn_jump_account = () => {
    this.props.history.push("/MyAccount")
  }

  btn_jump_identificationDoc = () => {
    this.props.history.push("/PersonalID")
  }

  btn_jump_visa = () => {
    this.props.history.push("/Visa")
  }

  btn_jump_police_check = () => {
    this.props.history.push("/PoliceCheck")
  }

  btn_jump_wwcc = () => {
    this.props.history.push("/wwcc")
  }

  btn_jump_ecec = () => {
    this.props.history.push("/ececcheck")
  }

  btn_pay_level_check = () => {
    this.props.history.push("/uploadPayLevel");
  };

  btn_jump_teacher_pay_level = () => {
    this.props.history.push("/TeacherPayLevelUpload");
  }

  btn_jump_security = () => {
    this.props.history.push("/")
  }

  btn_jump_bank_details = () => {
    this.props.history.push("/BankDetails");
  };

  btn_jump_tax = () => {
    this.props.history.push("/Tax");
  };

  btn_jump_super = () => {
    this.props.history.push("/Superannuation");
  };

  btn_jump_job_board = () => {
    this.props.history.push("/JobBoard");
  }

  btn_jump_saved_jobs = () => {
    this.props.history.push("/SavedJobs");
  }

  btn_jump_my_apps = () => {
    this.props.history.push("/MyApplications");
  }

  btn_jump_chat = () => {
    window.open("https://readyteacher.atlassian.net/servicedesk/customer/portal/6", "_blank")
  }

  btn_jump_user_manual = () => {
    this.props.history.push("/UserManual");
  }

  btn_jump_logout = () => {
    Auth.logout()
    this.props.logout();
    let userType = window.localStorage.getItem('userType');
    window.localStorage.clear()
    window.localStorage.setItem('userType', userType);
    this.props.history.push("/login")
  }

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  close = () => {
    this.setState({ isMenuOpen: false })
  }

  menuItem = (title, icon, onClick) => {
    return (
      <span className={icon ? `mdi mdi-${icon}` : ""} onClick={onClick}>
        <span className={icon ? "item-icon-inner" : ""}>{title}</span>
      </span>
    )
  }

  render() {
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: (
        <span onClick={this.toggle}>
          <i className="mdi mdi-menu"></i> Menu
        </span>
      ),
      align: "right",
      textAlign: "left",
      size: "md",
      className: "dropdown-menu-fix menu-button mobile-menu",
      animate: false,
      closeOnInsideClick: false,
    }

    // const nestedMenuOptions = (menuItem, icon, onClick) => {
    //   return {
    //     toggle: this.menuItem(menuItem, icon, onClick),
    //     delay: 0,
    //     openOnMouseover: false,
    //   };
    // };

    const user = this.props.user

    return (
      <div className="drop-down-box">
        <DropdownMenu {...menuOptions}>
          {user.role === "admin"
            ? [
              <li key="allocate">
                {this.menuItem(
                  "Assign Bookings",
                  "account-box",
                  this.btn_jump_admin_assignbookings
                )}
              </li>,
               <li key="availabilities">
               {this.menuItem(
                 "All Availabilities",
                 "account-multiple",
                 this.btn_jump_admin_allavalability
               )}
             </li>,
              <li key="allteachers">
                {this.menuItem(
                  "Teachers",
                  "account-multiple",
                  this.btn_jump_admin_allteachers
                )}
              </li>,
              <li key="allcolleges">
                {this.menuItem(
                  "Colleges",
                  "office-building",
                  this.btn_jump_admin_allcolleges
                )}
              </li>,
              <li key="allarchivedcolleges">
                {this.menuItem(
                  "Archived Colleges",
                  "office-building",
                  this.btn_jump_admin_allarchivedcolleges
                )}
              </li>,
              <li key="allocate">
                {this.menuItem(
                  "Teachers Pay Level",
                  "account-box",
                  this.btn_jump_teacher_pay_level
                )}
              </li>,
              <li key="allarchivedcolleges">
                {this.menuItem(
                  "Qualifications",
                  "office-building",
                  this.btn_jump_admin_qualification
                )}
              </li>,
              <li key="userlogs">
                {this.menuItem(
                  "User Logs",
                  "note-text",
                  this.btn_jump_admin_userlogs
                )}
              </li>
              // <li><div onClick={this.btn_jump_admin_allteachers} className="mdi mdi-account-multiple item-icon">
              //     <span className="item-icon-inner">Teachers</span>
              // </div></li>,
              // <li><div onClick={this.btn_jump_admin_allcolleges} className="mdi mdi-office-building item-icon">
              //     <span className="item-icon-inner">Colleges</span>
              // </div></li>,
              // <li><div onClick={this.btn_jump_admin_validatedocs} className="mdi mdi-calendar-check item-icon">
              //     <span className="item-icon-inner">Validate Teacher Documents</span>
              // </div></li>
            ]
            : [
              <li key="profile">
                {this.menuItem(
                  "Profile",
                  "account-circle-outline",
                  this.btn_jump_profile
                )}
              </li>,
              <li key="bookings">
                <details>
                  <summary>
                    {this.menuItem(
                      "Bookings & Availability",
                      "calendar-check"
                    )}
                  </summary>
                  <li key="calendar">
                    <div onClick={this.btn_jump_mycalendar}>My Calendar</div>
                  </li>
                  <li key="joblist">
                    <div onClick={this.btn_jump_joblist}>Jobs List</div>
                  </li>
                  {/* <li key="timesheets">
                    <div className="menu-item-disabled">Timesheets</div>
                  </li>
                  <li key="payments">
                    <div className="menu-item-disabled">Payments</div>
                  </li> */}
                </details>
              </li>,
              <li key="jobs">
                <details>
                  <summary>
                    {this.menuItem(
                      "Job Board",
                      "briefcase"
                    )}
                  </summary>
                  <li key="jobboard">
                    <div onClick={this.btn_jump_job_board}>
                      Job Board
                    </div>
                  </li>
                  <li key="savedjobs">
                    <div onClick={this.btn_jump_saved_jobs}>
                      Saved Jobs
                    </div>
                  </li>
                  <li key="applications">
                    <div onClick={this.btn_jump_my_apps}>
                      My Applications
                    </div>
                  </li>
                </details>
              </li>,
              <li key="personal">
                <details>
                  <summary>
                    {this.menuItem(
                      "Personal Information",
                      "account-card-details"
                    )}
                  </summary>
                  <li key="personaldetails">
                    <div onClick={this.btn_jump_information}>
                      Personal Details
                      </div>
                  </li>
                  <li key="contact">
                    <div onClick={this.btn_jump_emergency}>
                      Emergency Contact
                      </div>
                  </li>
                  <li key="work_location">
                    <div onClick={this.btn_jump_work_location}>
                      Work Locations
                    </div>
                  </li>
                  <li key="account">
                    <div
                      onClick={this.btn_jump_account}
                    // className="menu-item-disabled"
                    >
                      My Account
                      </div>
                  </li>
                </details>
              </li>,
              <li key="identification">
                <details>
                  <summary>
                    {this.menuItem("Identification", "account-check")}
                  </summary>
                  <li key="id">
                    <div onClick={this.btn_jump_identificationDoc}>
                      Personal I.D.
                      </div>
                  </li>
                  <li key="visa">
                    <div onClick={this.btn_jump_visa}>Visa Details</div>
                  </li>
                  <li key="police">
                    <div onClick={this.btn_jump_police_check}>
                      Police Check (Opt.)
                      </div>
                  </li>
                  <li key="wwcc">
                    <div onClick={this.btn_jump_wwcc}>WWCC (Opt.)</div>
                  </li>
                  {
                      this.state.user?.is_childhood_teacher && (
                        <li key="ecec">
                          <div onClick={this.btn_jump_ecec}>First AID</div>
                        </li>
                      )
                  }
                  {
                      !this.state.user?.is_childhood_teacher && <li key="pay">
                      <div onClick={this.btn_pay_level_check}>Pay Level</div>
                    </li>
                    }
                </details>
              </li>,
              <li key="banking">
                <details>
                  <summary>
                    {this.menuItem("Banking & Super", "credit-card-settings")}
                  </summary>
                  <li key="bankdetails">
                    <div onClick={this.btn_jump_bank_details}>Bank Details</div>
                  </li>
                  <li key="tax">
                    <div onClick={this.btn_jump_tax}>Tax Declaration</div>
                  </li>
                  <li key="super">
                    <div onClick={this.btn_jump_super}>Superannuation</div>
                  </li>
                </details>
              </li>,
              <li key="get-support">
                <details>
                  <summary>
                    {this.menuItem(
                      "Get Support",
                      "chat-processing"
                    )}
                  </summary>
                  <li key="helpdesk">
                    <div onClick={this.btn_jump_chat}>Helpdesk</div>
                  </li>
                  <li key="user-manual">
                    <div className="menu-item-disabled">User Manual</div>
                  </li>
                </details>
              </li>
            ]}
          <li key="logout">{this.menuItem("Logout", "power", this.btn_jump_logout)}</li>
        </DropdownMenu>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MobileMenu))
